module.exports = new Promise((resolve, reject) => {
    let remoteUrlWithVersionAV;
    const script = document.createElement("script");
    let cookies = document.cookie;
    const cookieArray = cookies.split(";").map((s) => s.split("=").map((s) => s.trim()))
        .reduce((m, [k, v]) => (m.set(k, v), m), new Map());

    const env = cookieArray.get("VANTAGE_ENV");
    //console.log("environent ", env);
    switch (env) {
        case "local":
            remoteUrlWithVersionAV = "http://localhost:3000/remoteEntry.js";
            break;
        case "dev":
            remoteUrlWithVersionAV =
                "https://az03-hc-app-askv-cmn-dev.az03-hc-ase-ev-cmn-dev.appserviceenvironment.net/remoteEntry.js";
            break;
        case "TestAzure":
        case "cexltest":
            remoteUrlWithVersionAV =
                "https://vantagetestaskv.exlservice.com/remoteEntry.js";
            break;
        case "TWNP":
            remoteUrlWithVersionAV =
                "https://askvcommonnp3.triwest.com/remoteEntry.js";
            break;
        case "TWSTG":
            remoteUrlWithVersionAV =
                "https://askvcommonstg.triwest.com/remoteEntry.js";
            break;
        case "TWPRD":
            remoteUrlWithVersionAV =
                "https://VantageASKV.triwest.com/remoteEntry.js";
            break;
        case "qa":
            remoteUrlWithVersionAV =
                "https://dev-exlvantage.exlservice.com/remoteEntry.js";
            break;
        case "hznuat":
        case "demouat":
        case "hpuat":
            remoteUrlWithVersionAV = "https://vantageuataskv.exlservice.com/remoteEntry.js";
            break;
        case "hznprod":
        case "chaprod":
        case "hpprod":
            remoteUrlWithVersionAV = "https://vantageprodaskv.exlservice.com/remoteEntry.js";
            break;
        case "chadr":
        case "chadrtest":
		case "hzndr":
        case "hzndrtest":
        case "hpdr":
        case "hpdrtest":
            remoteUrlWithVersionAV = "https://vantagedraskv.exlservice.com/remoteEntry.js";
            break;            
        case "lktuat":
            remoteUrlWithVersionAV = "http://localhost:3000/remoteEntry.js";
            break;
        case "lktuattest":
            remoteUrlWithVersionAV = "http://localhost:3000/remoteEntry.js";
            break;
        case "lktprod":
            remoteUrlWithVersionAV = "http://localhost:3000/remoteEntry.js";
            break;
        case "test":
            remoteUrlWithVersionAV = "https://testaskv-infolock.lockton.com/remoteEntry.js";
            break;
        case "Prod":
            remoteUrlWithVersionAV = "https://askv-infolock.lockton.com/remoteEntry.js";
            break;
        case "DR":
            remoteUrlWithVersionAV = "https://proddraskv-infolock.lockton.com/remoteEntry.js";
            break;
        case "DRPROD":
            remoteUrlWithVersionAV = "https://proddraskv-infolock.lockton.com/remoteEntry.js";
            break;
        default:
            remoteUrlWithVersionAV = "";
            break;
    }

    script.src = remoteUrlWithVersionAV + "?v=19.4";
    script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
            get: (request) => window.AskVantage.get(request),
            init: (arg) => {
                try {
                    return window.AskVantage.init(arg);
                } catch (e) {
                    console.log("remote container already initialized");
                }
            },
        };
        resolve(proxy);
    };
    script.onerror = () => {
        reject();
        //alert("Error loading " + this.src); // Error loading https://example.com/404.js
        // document.head.appendChild(null);
        //return null;
    };
    // inject this script with the src set to the versioned remoteEntry.js
    document.head.appendChild(script);
});